import React, { useState, useEffect } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import WeighageController from "./WeighageController/WeighageController";
import WeighageScoreController from "./WeighageScoreController/WeighageScoreController";
import WeightageScoreEligibleController from "./WeightageScoreEligibleController/WeightageScoreEligibleController";
function TabPanel(props) {
  const { children, value, index, ...other } = props;


  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}


TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any,
  value: PropTypes.any,
};
function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
   // display: "flex",
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    // width: "14%",
    "& .MuiTabs-indicator": {
      display: "none"
    }
  
  },
  tabPanels: {
    width: "86%",
  },
  Container: {
    marginTop:"20px"
  }
}));
const RuleEngineWeighage = ({classesChild}) => {
  const classes = useStyles();
  const params = useParams();
  let navigate = useNavigate();
  const [value, setValue] = React.useState(0);


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  const dispatch = useDispatch();


  return (
    <div className={classes.root}>
      <Tabs
        orientation="horizontal"
        variant="scrollable"
        value={value}
        onChange={handleChange}
      >
        <Tab label="Weightage" {...a11yProps(0)} />
        <Tab label="Weightage Score" {...a11yProps(1)} />
        <Tab label="Weightage Score Eligibility" {...a11yProps(2)} />
      </Tabs>
      <TabPanel value={value} index={0} className={classes.Container}>
        <WeighageController classes={classesChild}/>
      </TabPanel>
      <TabPanel value={value} index={1} className={classes.Container}>
        <WeighageScoreController classes={classesChild}/>
      </TabPanel>
      <TabPanel value={value} index={2} className={classes.Container}>
        <WeightageScoreEligibleController classes={classesChild}/>
      </TabPanel>
    </div>
  );
};


RuleEngineWeighage.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
  index: PropTypes.any,
  value: PropTypes.any,
};


export default RuleEngineWeighage;




